import { makeVar, useReactiveVar } from '@apollo/client';
import { ICountryList } from '@utils/types';
import { useEffect } from 'react';

export interface selectedCountryState {
  id: number;
  country_code: string;
  country_name: string;
  country_flag: string;
  iso_alpha_2_code: string;
}

export const selectedCountryVar = makeVar<selectedCountryState>({
  id: 0,
  country_code: '',
  country_name: '',
  country_flag: '',
  iso_alpha_2_code: '',
});

export const updateSelectedCountry = (country_code: string) => {
  selectedCountryVar({
    ...selectedCountryVar(),
    country_code,
  });

  localStorage.setItem(
    'iso_alpha_3_code',
    JSON.stringify(selectedCountryVar().country_code)
  );
};

export const usePersistentSelectedCountry = (
  getServiceableCountries: ICountryList[] | undefined,
  detectedCountryCode?: string
) => {
  const selectedCountryState = useReactiveVar(selectedCountryVar);

  useEffect(() => {
    if (detectedCountryCode && getServiceableCountries?.length) {
      const defaultCountryDetail = getServiceableCountries?.find(
        (country) => country.country_code === detectedCountryCode.toLowerCase()
      );
      if (defaultCountryDetail) {
        updateSelectedCountry(defaultCountryDetail?.country_code);

        selectedCountryVar({
          ...selectedCountryVar(),
          id: defaultCountryDetail?.id,
          country_code: defaultCountryDetail?.country_code,
          country_name: defaultCountryDetail?.country_name,
          country_flag: defaultCountryDetail?.country_flag,
          iso_alpha_2_code: defaultCountryDetail?.iso_alpha_2_code,
        });
      }

      if (!defaultCountryDetail) {
        const defaultCountryDetail = getServiceableCountries.find(
          (country) => country.country_code === 'usa'
        );
        updateSelectedCountry('usa');
        if (defaultCountryDetail) {
          selectedCountryVar({
            ...selectedCountryVar(),
            id: defaultCountryDetail?.id,
            country_code: defaultCountryDetail?.country_code,
            country_name: defaultCountryDetail?.country_name,
            country_flag: defaultCountryDetail?.country_flag,
            iso_alpha_2_code: defaultCountryDetail?.iso_alpha_2_code,
          });
        }
      }
    }
  }, [detectedCountryCode]);
  return selectedCountryState;
};
